import { useEffect, useState } from 'react';

import { useDispatch } from 'react-redux';

import { useNavigate } from 'react-router';

import { Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, FormControlLabel, FormLabel, Grid, InputBase, InputLabel, List, ListItem, ListItemText, MenuItem, Paper, Radio, RadioGroup, Select, Typography } from '@mui/material';

import SearchIcon from '@mui/icons-material/Search';
import PersonAddIcon from '@mui/icons-material/PersonAdd';

import moment from 'moment';

import { openSnackbar } from '../store/slices/SnackbarSlice';

import { InputSearchButtonsStyle, InputSearchStyle } from '../styles/FormStyle';

import { DialogBuscarAmparo } from './DialogBuscarAmparo';
import { DialogNuevaPersona } from './DialogNuevaPersona';
import { DialogBuscarPersona } from './DialogBuscarPersona';
import { DialogBuscarAcuerdo } from './DialogBuscarAcuerdo';

import { ObtenerMateria } from '../connections/catalogos/MateriaConnection';
import { BuscarIrregular } from '../connections/recepcion/IrregularConnection';
import { ObtenerTipoParte } from '../connections/catalogos/TipoParteConnection';
import { BuscarExpediente } from '../connections/recepcion/ExpedienteConnection';
import { ObtenerAutoridadesMaterias } from '../connections/catalogos/AutoridadConnection';
import { BuscarExhortoRecibido } from '../connections/recepcion/ExhortoRecibidoConnection';
import { NuevaNotificacion } from '../connections/notificaciones/NotificacionConnection';
import { ObtenerTipoNotificacion } from '../connections/catalogos/TipoNotificacionConnection';
import { ObtenerFormaNotificacion } from '../connections/catalogos/FormaNotificacionConnection';

import { ParteProps } from '../interfaces/recepcion/ParteInterface';
import { MateriaProps } from '../interfaces/catalogos/MateriaInterface';
import { TipoParteProps } from '../interfaces/catalogos/TipoParteInterface';
import { AutoridadProps } from '../interfaces/catalogos/AutoridadInterface';
import { TipoNotificacionProps } from '../interfaces/catalogos/TipoNotificacionInterface';
import { FormaNotificacionProps } from '../interfaces/catalogos/FormaNotificacionInterface';
import { defaultPersonaBusqueda, PersonaBusquedaProps } from '../interfaces/comun/PersonaInterface';
import { BuscarIrregularResponse, defaultIrregularResponse } from '../interfaces/recepcion/IrregularInterface';
import { AmparoProps, BuscarAmparoResponse, defaultBuscarAmparo } from '../interfaces/recepcion/AmparoInterface';
import { BuscarExpedienteResponse, defaultExpedienteResponse } from '../interfaces/recepcion/ExpedienteInterface';
import { BuscarExhortoRecibidoResponse, defaultExhortoRecibidoResponse } from '../interfaces/recepcion/ExhortoRecibidoInterface';
import { BuscarAcuerdoProps, BuscarAcuerdoResponse, defaultBuscarAcuerdoResponse } from '../interfaces/tribunal/AcuerdoInterface';

interface Props {
    openDialog:          boolean;
    handleCloseDialog:   () => void;
}

type TipoBusquedaType = '' | 'Expediente' | 'ExhortoRecibido' | 'Amparo' | 'Irregular';
type TipoParteType = '' | 'Actor/Demandado' | 'Otro';

export const DialogNuevaNotificacion = ( { openDialog, handleCloseDialog }: Props ) => {

    const dispatch = useDispatch();

    const navigate = useNavigate(); 
    
    const [loading, setLoading] = useState( false );
    const [loadingGuardar, setLoadingGuardar] = useState(false);

    const [openDialogNuevaPersona, setOpenDialogNuevaPersona] = useState( false );    
    const [openDialogBuscarPersona, setOpenDialogBuscarPersona] = useState( false );

    const [tipoBusqueda, setTipoBusqueda] = useState<TipoBusquedaType>( '' );  
    const [tipoParteNotificar, setTipoParteNotificar] = useState<TipoParteType>( '' );  

    const [parte, setParte] = useState( 0 );
    const [arrayParte, setArrayParte] = useState<ParteProps[]>( [] );

    const [tipoParte, setTipoParte] = useState( 0 );
    const [tipoParteArray, setTipoParteArray] = useState<TipoParteProps[]>( [] );

    const [tipoNotificacion, setTipoNotificacion] = useState( 0 );
    const [tipoNotificacionArray, setTipoNotificacionArray] = useState<TipoNotificacionProps[]>( [] ) ;

    const [formaNotificacion, setFormaNotificacion] = useState( 0 );
    const [formaNotificacionArray, setFormaNotificacionArray] = useState<FormaNotificacionProps[]>( [] ) ;

    const [materia, setMateria] = useState(0);
    const [materiaArray, setMateriaArray] = useState<MateriaProps[]>( [] );

    const [autoridad, setAutoridad] = useState(0);
    const [autoridadArray, setAutoridadArray] = useState<AutoridadProps[]>( [] );
    
    const [numeroExpediente, setNumeroExpediente] = useState('');
    const [expediente, setExpediente] = useState<BuscarExpedienteResponse>( defaultExpedienteResponse );

    const [numeroExhorto, setNumeroExhorto] = useState('');
    const [exhortoRecibido, setExhortoRecibido] = useState<BuscarExhortoRecibidoResponse>( defaultExhortoRecibidoResponse );

    const [numeroAmparo, setNumeroAmparo] = useState( '' );
    const [amparo, setAmparo] = useState<BuscarAmparoResponse>( defaultBuscarAmparo );
    const [openDialogBuscarAmparo, setOpenDialogBuscarAmparo] = useState( false );
    
    const [numeroIrregular, setNumeroIrregular] = useState('');
    const [irregular, setIrregular] = useState<BuscarIrregularResponse>( defaultIrregularResponse );
    
    const [personaBusqueda, setPersonaBusqueda] = useState<PersonaBusquedaProps>( defaultPersonaBusqueda );
    
    const [acuerdoBusqueda, setAcuerdoBusqueda] = useState<BuscarAcuerdoResponse>( defaultBuscarAcuerdoResponse );
    const [openDialogBuscarAcuerdo, setOpenDialogBuscarAcuerdo] = useState( false );

    const { nombreCompleto } = personaBusqueda;

    const seleccionarPersona = ( persona: PersonaBusquedaProps ) => setPersonaBusqueda( persona )
    
    const seleccionarAmparo = ( amparo: AmparoProps ) => { 

        if( amparo.idAmparo !== 0){

            setNumeroAmparo( amparo.numeroAmparo ?? amparo.numeroAmparoOrigen ); 
            
            setAmparo({ 
                success: true,
                message: 'Se encontró el amparo correctamente',
                ...amparo 
            }); 
            
            setArrayParte( amparo.partes );
        }
        else{            
            dispatch( openSnackbar({ message: 'No se encontró el número de amparo', variant: 'error' }));  
        }

    }
        
    const seleccionarAcuerdo = ( acuerdo: BuscarAcuerdoProps ) => {
        
        if( acuerdo.idAcuerdo !== 0){
            
            setAcuerdoBusqueda({ 
                success: true,
                message: 'Se encontró el amparo correctamente',
                ...acuerdo 
            }); 
            
        }

    }

    const handleGenerarNotificacion = async () => {   

        let persona = 0;
        let tipo = 0;

        if( tipoParteNotificar === "Otro" ){
            persona = personaBusqueda.idPersona ?? 0;
            tipo = tipoParte;
        }
        else {
            if( parte !== 0 ){

                const parteFind = arrayParte.find(( ( elem ) => elem.id === parte ));
                persona = parteFind?.idPersona ?? 0;
                tipo = parteFind?.idTipoParte ?? 0;
            }
        }    

        setLoadingGuardar(true);    
        
        const params = {
            idTipoNotificacion: tipoNotificacion,
            idFormaNotificacion: formaNotificacion,
            idPersona: persona ?? 0,
            idTipoParte: tipo,
            idExpediente: expediente?.idExpediente ?? 0,
            idIrregular: irregular?.idIrregular ?? 0,
            idAmparo: amparo?.idAmparo ?? 0,
            idExhortoRecibido: exhortoRecibido?.idExhortoRecibido ?? 0,
            idAcuerdo: acuerdoBusqueda?.idAcuerdo ?? 0,
        }
        
        await NuevaNotificacion( params ).then( resp => {

            const { success, idNotificacion } = resp;

            if( success ){
                
                setTimeout(() => {       
                    
                    setLoadingGuardar(false);   

                    navigate(`/notificacion/generar/${ idNotificacion }`);        

                    handleCloseDialog();

                }, 700);
                
                setTimeout(() => {            

                    setLoadingGuardar(false);                    

                }, 1000);
            }
            else{                    

                setTimeout(() => {

                    setLoadingGuardar( false );  

                }, 700); 
               
            }   
        });     
             
    }

    const handleBuscarExpediente = async () => {

        setLoading( true ); 

        await BuscarExpediente({ numeroExpediente, idAutoridad: autoridad }).then( resp => {

            const { success, message } = resp;

            if( success ){

                setTimeout(() => {

                    handleClear();

                    setExpediente( resp );
                    setArrayParte( resp.partes);
                    setLoading( false );                     

                }, 700);  

            }
            else {

                setTimeout(() => {

                    handleClear();
                    setLoading( false ); 
                    
                    dispatch( openSnackbar({ message, variant: 'error' }) );

                }, 700);  

            }

        });    

    }

    const handleBuscarExhortoRecibido = async () => {

        setLoading( true ); 

        await BuscarExhortoRecibido({ numeroExhortoRecibido: numeroExhorto, idAutoridad: autoridad }).then( resp => {

            const { success, message } = resp;

            if( success ){


                setTimeout(() => {

                    handleClear();

                    setExhortoRecibido( resp );
                    setArrayParte( resp.partes);              
                    setLoading( false ); 
                    
                }, 700);  

            }
            else {

                setTimeout(() => {

                    handleClear();
                    setLoading( false ); 
                    setArrayParte( resp.partes);      
                    dispatch( openSnackbar({ message, variant: 'error' }) );

                }, 700);  

            }

        });    

    }

    const handleBuscarIrregular = async () => {

        setLoading( true ); 

        await BuscarIrregular({ numeroIrregular: numeroIrregular, idAutoridad: autoridad }).then( resp => {

            const { success, message } = resp;

            if( success ){

                setTimeout(() => {

                    handleClear();

                    setIrregular( resp );
                    setArrayParte( resp.partes);     
                    setLoading( false ); 
                    
                }, 700);  

            }
            else {

                setTimeout(() => {

                    handleClear();
                    setLoading( false ); 
                    
                    dispatch( openSnackbar({ message, variant: 'error' }) );

                }, 700);  

            }

        });    

    }

    const handleClear = () => {
        
        setMateria( 0 );
        setAutoridad( 0 );
        setAutoridadArray( [] );
        setArrayParte([]);
        setParte( 0 );

        setNumeroExpediente( '' );
        setExpediente( defaultExpedienteResponse );

        setNumeroExhorto( '' );
        setExhortoRecibido( defaultExhortoRecibidoResponse );

        setNumeroAmparo( '' );
        setAmparo( defaultBuscarAmparo );

        setNumeroIrregular( '' );
        setIrregular( defaultIrregularResponse );
        setPersonaBusqueda( defaultPersonaBusqueda );

        setTipoParteNotificar("Actor/Demandado");

    }

    const handleClearDialog = () => {
        
        setMateria( 0 );
        setAutoridad( 0 );
        setAutoridadArray( [] );
        setArrayParte([]);

        setNumeroExpediente( '' );
        setExpediente( defaultExpedienteResponse );

        setNumeroExhorto( '' );
        setExhortoRecibido( defaultExhortoRecibidoResponse );

        setNumeroAmparo( '' );
        setAmparo( defaultBuscarAmparo );

        setNumeroIrregular( '' );
        setIrregular( defaultIrregularResponse );

        setPersonaBusqueda(defaultPersonaBusqueda);

        setTipoBusqueda('');
        setTipoNotificacion(0);
        setFormaNotificacion(0);

        setTipoParte(0);

        setTipoParteNotificar("Actor/Demandado");
        setParte(0);
        

    }

    const handleCerrarDialog = () => {
        
        handleClearDialog();
        handleCloseDialog();
    
    }

    const handleChangeTipoBusqueda = ( value: TipoBusquedaType ) => {
        
        setTipoBusqueda( value );
        handleClear();
        
        setParte( 0 );
        setArrayParte( [] );

    }

    const handleNuevaPersona = ( value: TipoParteType ) => {

        setTipoParteNotificar( value);
        setParte( 0 );
        setPersonaBusqueda( defaultPersonaBusqueda );              
        setTipoParte( 0 );     

    }
   
    useEffect(() => {
        
        async function Obtener(){    

            await ObtenerMateria().then( resp => {              
                setMateriaArray( resp );                 
            });

        }

        Obtener();

    }, [ ]);

    useEffect(() => {
           
        async function Obtener(){    

            setAutoridad( 0 );
            setAutoridadArray( [] );

            await ObtenerAutoridadesMaterias( materia ).then( resp => {              
                setAutoridadArray( resp );                 
            });

        }

        if( materia !== 0 ){
            Obtener();
        }

    }, [ materia ]);

    useEffect(() => {
        
        async function Obtener(){    

            await ObtenerTipoNotificacion().then( resp => {              
                setTipoNotificacionArray( resp );                 
            });

        }

        Obtener();

    }, [ ]);

    useEffect(() => {
        
        async function Obtener(){    

            await ObtenerFormaNotificacion().then( resp => {              
                setFormaNotificacionArray( resp );                 
            });

        }

        Obtener();

    }, [ ]);

    useEffect(() => {
        
        async function Obtener(){    

            await ObtenerTipoParte().then( resp => {              
                setTipoParteArray( resp );                 
            });

        }

        Obtener();

    }, [ ]);

    return (
        <>

            <Dialog open={ openDialog } maxWidth='md' fullWidth={true} >

                <DialogTitle>Nueva notificación</DialogTitle>
            
                <DialogContent>
                    
                    <Grid container spacing={3} mt={1}>
                        
                        <Grid size={{ xs: 12, md: 6 }}>
                                                                    
                            <FormControl required fullWidth>
                                
                                <InputLabel>Tipo de notificación</InputLabel>
                                                             
                                <Select                                                                          
                                    label="Tipo de notificación"
                                    value={ tipoNotificacion }
                                    onChange={ ( e ) => setTipoNotificacion( parseInt( e.target.value.toString() ) ) }
                                    
                                >
                                    <MenuItem key={0} value={0}>Selecciona una opción</MenuItem>      
                                    {
                                        tipoNotificacionArray
                                        .filter( ({ idTipoNotificacion }) => idTipoNotificacion === 1 || idTipoNotificacion === 2 || idTipoNotificacion === 5 )
                                        .map( ({ idTipoNotificacion, descripcion }) => (
                                            <MenuItem key={ idTipoNotificacion } value={ idTipoNotificacion }>{ descripcion }</MenuItem>                                                        
                                        ))
                                    }  
                                </Select>

                            </FormControl>

                        </Grid>   
               
                        <Grid size={{ xs: 12, md: 6 }}>
                                                                    
                            <FormControl required fullWidth>
                                
                                <InputLabel>Forma de notificación</InputLabel>
                            
                                <Select                                                                          
                                    label="Forma de notificación"
                                    value={ formaNotificacion }
                                    onChange={ ( e ) => setFormaNotificacion( parseInt( e.target.value.toString() ) ) }
                                >
                                    <MenuItem key={0} value={0}>Selecciona una opción</MenuItem>    
                                    
                                    {
                                        tipoNotificacion === 1
                                        ?
                                            formaNotificacionArray
                                            .filter( ({ idFormaNotificacion }) => idFormaNotificacion === 1 )
                                            .map( ({ idFormaNotificacion, descripcion }) => (
                                                <MenuItem key={ idFormaNotificacion } value={ idFormaNotificacion }>{ descripcion }</MenuItem>                                                        
                                            ))
                                        :
                                            formaNotificacionArray
                                            .map( ({ idFormaNotificacion, descripcion }) => (
                                                <MenuItem key={ idFormaNotificacion } value={ idFormaNotificacion }>{ descripcion }</MenuItem>                                                        
                                            ))
                                    }    

                                </Select>

                            </FormControl>

                        </Grid>   

                        <Grid size={{ xs: 12, md: 12 }}>

                            <FormControl>

                                <FormLabel>Generar notificación para:</FormLabel>
                                <RadioGroup row>    

                                    <FormControlLabel 
                                        label="Expediente" 
                                        control={ <Radio checked={ tipoBusqueda === 'Expediente' } 
                                        onChange={ () => handleChangeTipoBusqueda('Expediente') } />} 
                                    />                                  
                                    
                                    <FormControlLabel 
                                        label="Exhorto recibido" 
                                        control={ <Radio checked={ tipoBusqueda === 'ExhortoRecibido' } 
                                        onChange={ () => handleChangeTipoBusqueda('ExhortoRecibido') } />} 
                                    />       

                                
                                    <FormControlLabel 
                                        label="Amparo" 
                                        control={ <Radio checked={ tipoBusqueda === 'Amparo' } 
                                        onChange={ () => handleChangeTipoBusqueda('Amparo') } />} 
                                    />                                    
                                    
                                    <FormControlLabel 
                                        label="Irregular" 
                                        control={ <Radio checked={ tipoBusqueda === 'Irregular' } 
                                        onChange={ () => handleChangeTipoBusqueda('Irregular') } />} 
                                    />                                
                                      
                                </RadioGroup>

                            </FormControl>

                        </Grid>
                        
                        {/* -------------------------------------------------------------------------------------------------------------------- */}
                        
                        <Grid size={{ xs: 12, md: 4 }}>
                                                                                             
                            <FormControl required fullWidth>
                                
                                <InputLabel>Materia</InputLabel>
                            
                                <Select                                                                          
                                    label="Materia"
                                    value={ materia }
                                    onChange={ ( e ) => setMateria( parseInt( e.target.value.toString() ) ) }
                                >
                                    <MenuItem key={0} value={0}>Selecciona una opción</MenuItem>                        
                                    {
                                        materiaArray
                                        .filter( ({ idMateria }) => idMateria === 5 || idMateria === 6 )
                                        .map( ({ idMateria, descripcion }) => (
                                            <MenuItem key={ idMateria } value={ idMateria }>{ descripcion }</MenuItem>                                                        
                                        ))
                                    }                     
                                    
                                </Select>

                            </FormControl>

                        </Grid>   

                        <Grid size={{ xs: 12, md: 8 }}>
                        
                            <FormControl required fullWidth>
                                
                                <InputLabel>Autoridad</InputLabel>
                            
                                <Select                                                                          
                                    label="Autoridad"
                                    value={ autoridad }
                                    onChange={ ( e ) => setAutoridad( parseInt( e.target.value.toString() ) ) }
                                    disabled={ materia === 0 }
                                >
                                    <MenuItem key={0} value={0}>Selecciona una opción</MenuItem>                        
                                    {
                                        autoridadArray.map( ({ idAutoridad, descripcion }) => (
                                            <MenuItem key={ idAutoridad } value={ idAutoridad }>{ descripcion }</MenuItem>                                                        
                                        ))
                                    }                     
                                    
                                </Select>

                            </FormControl>

                        </Grid>         

                        {/* ---------------------  Busqueda por expediente  -------------------------------------- */}
                        
                        {
                            tipoBusqueda === 'Expediente' 
                            && 
                                <Grid size={12}> 

                                    <Paper
                                        component="div"
                                        sx={ InputSearchStyle }
                                    >                    
                                        
                                        <InputBase 
                                            sx={{ ml: 1, flex: 1 }}                        
                                            placeholder="Buscar por número de expediente"     
                                            value={ numeroExpediente } 
                                            onChange={ ( e ) => { setNumeroExpediente( e.target.value ) }}
                                        />

                                        <Button 
                                            type="button" 
                                            variant='contained'                                  
                                            size='small'
                                            sx={ InputSearchButtonsStyle } 
                                            loading={ loading }
                                            disabled={ autoridad === 0 }
                                            onClick={ handleBuscarExpediente }
                                        >
                                            <SearchIcon />
                                        </Button>            

                                    </Paper>
                                    
                                </Grid>
                        }         

                        {
                            expediente.success
                            &&
                                <>

                                    <Grid size={{ md: 6, xs: 12 }}>
    
                                        <List disablePadding>
                            
                                            <ListItem sx={{ py: 0, px: 0 }}>
    
                                                <ListItemText
                                                    sx={{ mr: 2 }}
                                                    primary={ <Typography variant='subtitle2' sx={{ color: 'text.secondary' }}> Número de expediente: </Typography> }
                                                    secondary={ 
                                                        expediente.numeroFolio
                                                        ?
                                                            <Typography variant='subtitle2' fontWeight={'bold'}> { expediente.numeroExpediente } (F. { expediente.numeroFolio }) </Typography> 
                                                        :
                                                            <Typography variant='subtitle2' fontWeight={'bold'}> { expediente.numeroExpediente } </Typography> 
                                                    }
                                                />
    
                                            </ListItem>
    
                                        </List>
                                        
                                    </Grid>           
                                    
                                    <Grid size={{ md: 6, xs: 12 }}>

                                        <List disablePadding>
                            
                                            <ListItem sx={{ py: 0, px: 0 }}>

                                                <ListItemText
                                                    sx={{ mr: 2 }}
                                                    primary={ <Typography variant='subtitle2' sx={{ color: 'text.secondary' }}> Tipo de juicio: </Typography> }
                                                    secondary={ <Typography variant='subtitle2' fontWeight={'bold'}> { expediente.tipoJuicio } </Typography> }
                                                />

                                            </ListItem>

                                        </List>
                                    
                                    </Grid> 

                                    {
                                        expediente.actores.length !== 0 
                                        &&                              
                                            <Grid size={{ md: 6, xs: 12 }}>

                                                <List disablePadding>
                                    
                                                    <ListItem sx={{ py: 0, px: 0 }}>

                                                        <ListItemText
                                                            sx={{ mr: 2 }}
                                                            primary={ <Typography variant='subtitle2' sx={{ color: 'text.secondary' }}> Actor(es): </Typography> }
                                                            slotProps={{ secondary: { component: 'div' } }}
                                                            secondary={
                                                                <>
                                                                    <List disablePadding>
                                                                        {
                                                                            expediente.actores.map( ( actor, index ) => (
                                                                                <ListItem key={ index } sx={{ py: 0, px: 0 }}>
                                                                                    <Typography color='black' variant='subtitle2' fontWeight={'bold'}> { actor } </Typography>
                                                                                </ListItem>
                                                                            ))
                                                                        }                                                        
                                                                    </List>       
                                                                </>                                                         
                                                            }
                                                        />

                                                    </ListItem>

                                                </List>
                                            
                                            </Grid> 
                                    }

                                    {
                                        expediente.demandados.length !== 0 
                                        &&
                                            <Grid size={{ md: 6, xs: 12 }}>

                                                <List disablePadding>
                                    
                                                    <ListItem sx={{ py: 0, px: 0 }}>

                                                        <ListItemText
                                                            sx={{ mr: 2 }}
                                                            primary={ <Typography variant='subtitle2' sx={{ color: 'text.secondary' }}> Demandado(s): </Typography> }
                                                            slotProps={{ secondary: { component: 'div' } }}
                                                            secondary={
                                                                <>
                                                                    <List disablePadding>
                                                                        {
                                                                            expediente.demandados.map( ( demandado, index ) => (
                                                                                <ListItem key={ index } sx={{ py: 0, px: 0 }}>
                                                                                    <Typography color='black' variant='subtitle2' fontWeight={'bold'}> { demandado } </Typography>
                                                                                </ListItem>
                                                                            ))
                                                                        }                                                        
                                                                    </List>          
                                                                </>                                                      
                                                            }
                                                        />

                                                    </ListItem>

                                                </List>
                                            
                                            </Grid> 
                                    }

                                </>
                        }

                        {/* ---------------------  Busqueda por exhorto recibido  -------------------------------------- */}
                        
                        {
                            tipoBusqueda === 'ExhortoRecibido' 
                            && 
                                <Grid size={12}> 

                                    <Paper
                                        component="div"
                                        sx={ InputSearchStyle }
                                    >                    
                                        
                                        <InputBase 
                                            sx={{ ml: 1, flex: 1 }}                        
                                            placeholder="Buscar por número de exhorto"     
                                            value={ numeroExhorto } 
                                            onChange={ ( e ) => setNumeroExhorto( e.target.value ) }
                                        />

                                        <Button 
                                            type="button" 
                                            variant='contained'                                  
                                            size='small'
                                            sx={ InputSearchButtonsStyle } 
                                            loading={ loading }
                                            disabled={ autoridad === 0 }
                                            onClick={ handleBuscarExhortoRecibido }
                                        >
                                            <SearchIcon />
                                        </Button>            

                                    </Paper>
                                    
                                </Grid>
                        }      

                        {
                            exhortoRecibido.success
                            &&
                                <>

                                    <Grid size={{ md: 6, xs: 12 }}>
    
                                        <List disablePadding>
                            
                                            <ListItem sx={{ py: 0, px: 0 }}>
    
                                                <ListItemText
                                                    sx={{ mr: 2 }}
                                                    primary={ <Typography variant='subtitle2' sx={{ color: 'text.secondary' }}> Número de exhorto: </Typography> }
                                                    secondary={ 
                                                        exhortoRecibido.numeroFolio
                                                        ?
                                                            <Typography variant='subtitle2' fontWeight={'bold'}> { exhortoRecibido.numeroExhorto } (F. { exhortoRecibido.numeroFolio }) </Typography> 
                                                        :
                                                            <Typography variant='subtitle2' fontWeight={'bold'}> { exhortoRecibido.numeroExhorto } </Typography> 
                                                    }
                                                />
    
                                            </ListItem>
    
                                        </List>
                                        
                                    </Grid>         

                                    <Grid size={{ md: 6, xs: 12 }}>

                                        <List disablePadding>
                            
                                            <ListItem sx={{ py: 0, px: 0 }}>

                                                <ListItemText
                                                    sx={{ mr: 2 }}
                                                    primary={ <Typography variant='subtitle2' sx={{ color: 'text.secondary' }}> Tipo de juicio: </Typography> }
                                                    secondary={ <Typography variant='subtitle2' fontWeight={'bold'}> { exhortoRecibido.tipoJuicio } </Typography> }
                                                />

                                            </ListItem>

                                        </List>
                                    
                                    </Grid>   
                                    
                                    <Grid size={{ md: 6, xs: 12 }}>

                                        <List disablePadding>
                            
                                            <ListItem sx={{ py: 0, px: 0 }}>

                                                <ListItemText
                                                    sx={{ mr: 2 }}
                                                    primary={ <Typography variant='subtitle2' sx={{ color: 'text.secondary' }}> Número de expediente de origen: </Typography> }
                                                    secondary={ <Typography variant='subtitle2' fontWeight={'bold'}> { exhortoRecibido.numeroExpedienteOrigen } </Typography> }
                                                />

                                            </ListItem>

                                        </List>
                                    
                                    </Grid> 

                                    <Grid size={{ md: 6, xs: 12 }}>

                                        <List disablePadding>
                            
                                            <ListItem sx={{ py: 0, px: 0 }}>

                                                <ListItemText
                                                    sx={{ mr: 2 }}
                                                    primary={ <Typography variant='subtitle2' sx={{ color: 'text.secondary' }}> Autoridad del exhorto: </Typography> }
                                                    secondary={ <Typography variant='subtitle2' fontWeight={'bold'}> { exhortoRecibido.autoridadExhortoRecibido } </Typography> }
                                                />

                                            </ListItem>

                                        </List>
                                    
                                    </Grid>             

                                    {
                                        exhortoRecibido.actores.length !== 0 
                                        &&                              
                                            <Grid size={{ md: 6, xs: 12 }}>

                                                <List disablePadding>
                                    
                                                    <ListItem sx={{ py: 0, px: 0 }}>

                                                        <ListItemText
                                                            sx={{ mr: 2 }}
                                                            primary={ <Typography variant='subtitle2' sx={{ color: 'text.secondary' }}> Actor(es): </Typography> }
                                                            slotProps={{ secondary: { component: 'div' } }}
                                                            secondary={
                                                                <>
                                                                    <List disablePadding>
                                                                        {
                                                                            exhortoRecibido.actores.map( ( actor, index ) => (
                                                                                <ListItem key={ index } sx={{ py: 0, px: 0 }}>
                                                                                    <Typography color='black' variant='subtitle2' fontWeight={'bold'}> { actor } </Typography>
                                                                                </ListItem>
                                                                            ))
                                                                        }                                                        
                                                                    </List>     
                                                                </>                                                           
                                                            }
                                                        />

                                                    </ListItem>

                                                </List>
                                            
                                            </Grid> 
                                    }

                                    {
                                        exhortoRecibido.demandados.length !== 0 
                                        &&
                                            <Grid size={{ md: 6, xs: 12 }}>

                                                <List disablePadding>
                                    
                                                    <ListItem sx={{ py: 0, px: 0 }}>

                                                        <ListItemText
                                                            sx={{ mr: 2 }}
                                                            primary={ <Typography variant='subtitle2' sx={{ color: 'text.secondary' }}> Demandado(s): </Typography> }
                                                            slotProps={{ secondary: { component: 'div' } }}
                                                            secondary={
                                                                <>
                                                                    <List disablePadding>
                                                                        {
                                                                            exhortoRecibido.demandados.map( ( demandado, index ) => (
                                                                                <ListItem key={ index } sx={{ py: 0, px: 0 }}>
                                                                                    <Typography color='black' variant='subtitle2' fontWeight={'bold'}> { demandado } </Typography>
                                                                                </ListItem>
                                                                            ))
                                                                        }                                                        
                                                                    </List>   
                                                                </>                                                             
                                                            }
                                                        />

                                                    </ListItem>

                                                </List>
                                            
                                            </Grid> 
                                    }

                                </>
                        }    

                        {/* ---------------------  Busqueda por irregular  -------------------------------------- */}
                                                  
                        {
                            tipoBusqueda === 'Irregular' 
                            && 
                                <Grid size={12}> 

                                    <Paper
                                        component="div"
                                        sx={ InputSearchStyle }
                                    >                    
                                        
                                        <InputBase 
                                            sx={{ ml: 1, flex: 1 }}                        
                                            placeholder="Buscar por número de irregular"     
                                            value={ numeroIrregular } 
                                            onChange={ ( e ) => setNumeroIrregular( e.target.value ) }
                                        />

                                        <Button 
                                            type="button" 
                                            variant='contained'                                  
                                            size='small'
                                            sx={ InputSearchButtonsStyle } 
                                            loading={ loading }
                                            disabled={ autoridad === 0 }
                                            onClick={ handleBuscarIrregular }
                                        >
                                            <SearchIcon />
                                        </Button>            

                                    </Paper>
                                    
                                </Grid>
                        }      

                        {
                            irregular.success
                            &&
                                <>

                                    <Grid size={{ md: 6, xs: 12 }}>
    
                                        <List disablePadding>
                            
                                            <ListItem sx={{ py: 0, px: 0 }}>
    
                                                <ListItemText
                                                    sx={{ mr: 2 }}
                                                    primary={ <Typography variant='subtitle2' sx={{ color: 'text.secondary' }}> Número de irregular: </Typography> }
                                                    secondary={ 
                                                        irregular.numeroExpediente
                                                        ?
                                                            <Typography variant='subtitle2' fontWeight={'bold'}> { irregular.numeroIrregular } (Exp. { irregular.numeroExpediente }) </Typography> 
                                                        :
                                                            <Typography variant='subtitle2' fontWeight={'bold'}> { irregular.numeroIrregular } </Typography> 
                                                    }
                                                />
    
                                            </ListItem>
    
                                        </List>
                                        
                                    </Grid>       

                                    {
                                        irregular.actores.length !== 0 
                                        &&                              
                                            <Grid size={{ md: 6, xs: 12 }}>

                                                <List disablePadding>
                                    
                                                    <ListItem sx={{ py: 0, px: 0 }}>

                                                        <ListItemText
                                                            sx={{ mr: 2 }}
                                                            primary={ <Typography variant='subtitle2' sx={{ color: 'text.secondary' }}> Actor(es): </Typography> }
                                                            slotProps={{ secondary: { component: 'div' } }}
                                                            secondary={
                                                                <>
                                                                    <List disablePadding>
                                                                        {
                                                                            irregular.actores.map( ( actor, index ) => (
                                                                                <ListItem key={ index } sx={{ py: 0, px: 0 }}>
                                                                                    <Typography color='black' variant='subtitle2' fontWeight={'bold'}> { actor } </Typography>
                                                                                </ListItem>
                                                                            ))
                                                                        }                                                        
                                                                    </List>     
                                                                </>                                                           
                                                            }
                                                        />

                                                    </ListItem>

                                                </List>
                                            
                                            </Grid> 
                                    }

                                    {
                                        irregular.demandados.length !== 0 
                                        &&
                                            <Grid size={{ md: 6, xs: 12 }}>

                                                <List disablePadding>
                                    
                                                    <ListItem sx={{ py: 0, px: 0 }}>

                                                        <ListItemText
                                                            sx={{ mr: 2 }}
                                                            primary={ <Typography variant='subtitle2' sx={{ color: 'text.secondary' }}> Demandado(s): </Typography> }
                                                            slotProps={{ secondary: { component: 'div' } }}
                                                            secondary={
                                                                <>
                                                                    <List disablePadding>
                                                                        {
                                                                            irregular.demandados.map( ( demandado, index ) => (
                                                                                <ListItem key={ index } sx={{ py: 0, px: 0 }}>
                                                                                    <Typography color='black' variant='subtitle2' fontWeight={'bold'}> { demandado } </Typography>
                                                                                </ListItem>
                                                                            ))
                                                                        }                                                        
                                                                    </List>   
                                                                </>                                                             
                                                            }
                                                        />

                                                    </ListItem>

                                                </List>
                                            
                                            </Grid> 
                                    }

                                </>
                        }

                        {/* -------------------------  Busqueda por amparo  ------------------------------------- */}

                        {
                            tipoBusqueda === 'Amparo' 
                            && 
                                <Grid size={12}> 

                                    <Paper
                                        component="div"
                                        sx={ InputSearchStyle }
                                    >                    
                                        
                                        <InputBase 
                                            sx={{ ml: 1, flex: 1 }}                        
                                            placeholder="Buscar amparo por número auxiliar, número de origen, número de expediente"     
                                            value={ numeroAmparo } 
                                            onChange={ ( e ) => setNumeroAmparo( e.target.value ) }
                                            disabled
                                        />

                                        <Button 
                                            type="button" 
                                            variant='contained'                                  
                                            size='small'
                                            sx={ InputSearchButtonsStyle } 
                                            loading={ loading }
                                            disabled={ autoridad === 0 }
                                            onClick={ () => setOpenDialogBuscarAmparo( true ) }
                                        >
                                            <SearchIcon />
                                        </Button>            

                                    </Paper>
                                    
                                </Grid>
                        }      

                        {
                            amparo.success
                            &&
                                <Grid size={{ md: 12, xs: 12 }}>

                                    <Grid container spacing={3}>

                                        {
                                            amparo.numeroAmparo
                                            &&
                                                <Grid size={{ md: 6, xs: 12 }}>

                                                    <Typography variant='subtitle2' sx={{ color: 'text.secondary' }}> Número auxiliar de amparo: </Typography>
                                                    <Typography variant='subtitle2' fontWeight={'bold'}> { amparo.numeroAmparo } </Typography>                                            

                                                </Grid>
                                        }

                                        {
                                            ( !amparo.numeroAmparo && amparo.numeroAmparoOrigen )
                                            &&
                                                <Grid size={{ md: 6, xs: 12 }}>

                                                    <Typography variant='subtitle2' sx={{ color: 'text.secondary' }}> Número de amparo de origen: </Typography>
                                                    <Typography variant='subtitle2' fontWeight={'bold'}> { amparo.numeroAmparoOrigen } </Typography>                                            

                                                </Grid>
                                        }

                                        {
                                            ( amparo.numeroAmparoOrigen && amparo.idTipoAmparo !== 1 )
                                            &&
                                                <Grid size={{ md: 6, xs: 12 }}>

                                                    <Typography variant='subtitle2' sx={{ color: 'text.secondary' }}> Número de origen del amparo: </Typography>
                                                    <Typography variant='subtitle2' fontWeight={'bold'}> { amparo.numeroAmparoOrigen } </Typography>                                            

                                                </Grid>
                                        }    

                                        {
                                            amparo.numeroExpediente
                                            &&
                                                <Grid size={{ md: 6, xs: 12 }}>

                                                    <Typography variant='subtitle2' sx={{ color: 'text.secondary' }}> Número de expediente: </Typography>
                                                    <Typography variant='subtitle2' fontWeight={'bold'}> { amparo.numeroExpediente } </Typography>                                            

                                                </Grid>
                                        }                           
                                    
                                        <Grid size={{ md: 6, xs: 12 }}>
                                                
                                            <Typography variant='subtitle2' sx={{ color: 'text.secondary' }}> Tipo de amparo: </Typography> 
                                            <Typography variant='subtitle2' fontWeight={'bold'}> { amparo.tipoAmparo } </Typography>                                                   

                                        </Grid>                                   
                                    
                                        <Grid size={{ md: 6, xs: 12 }}>
                                                
                                            <Typography variant='subtitle2' sx={{ color: 'text.secondary' }}> Autoridad del amparo: </Typography> 
                                            <Typography variant='subtitle2' fontWeight={'bold'}> { amparo.autoridadAmparo } </Typography>                                                   

                                        </Grid>         

                                        {
                                            amparo.partes.length !== 0
                                            &&
                                                <Grid size={{ md: 6, xs: 12 }}>
                                                    <Typography variant='subtitle2' sx={{ color: 'text.secondary' }}> Partes: </Typography> 

                                                    <List disablePadding>
                                                        {                                                            
                                                            amparo.partes.map( ({ persona, tipoParte }, index ) => (
                                                                <ListItem key={ index } disableGutters>
                                                                    <ListItemText>
                                                                        <Typography variant='subtitle2' fontWeight={'bold'}>{ persona }</Typography>
                                                                        <Typography variant='body2'>({ tipoParte })</Typography>
                                                                    </ListItemText>                                                                         
                                                                </ListItem>
                                                            ))
                                                        }
                                                    </List>                                       

                                                </Grid>
                                        }                          

                                    </Grid>
                                
                                </Grid>
                        }    
                        
                        {/* -------------------------------------------------------------------------------------------------------------------- */}

                        <Grid size={{ md: 12, xs: 12 }}>

                            <FormControl>

                                <FormLabel>Selecciona el tipo de parte a notificar:</FormLabel>
                                <RadioGroup row>    
                                        
                                    <FormControlLabel 
                                        label="Actor/Demandado" 
                                        control={ <Radio checked={ tipoParteNotificar === 'Actor/Demandado' } 
                                        onChange={ () =>  handleNuevaPersona('Actor/Demandado') } />} 
                                    />  
                        
                                    <FormControlLabel 
                                        label="Otro" 
                                        control={ <Radio checked={ tipoParteNotificar === 'Otro' } 
                                        onChange={()=> handleNuevaPersona('Otro') } />}
                                    />                
                                      
                                </RadioGroup>

                            </FormControl>

                        </Grid>

                        {
                            tipoParteNotificar === 'Actor/Demandado'
                            &&
                                <Grid size={{ md: 12, xs: 12 }}>
                                                                            
                                    <FormControl required fullWidth>
                                        
                                        <InputLabel>Seleccione una persona a notificar</InputLabel>
                                    
                                        <Select                                                                          
                                            label="Seleccione una persona a notificar"
                                            value={ parte }
                                            onChange={ (e) => { setParte(e.target.value); } }    
                                        >

                                            <MenuItem key={0} value={0}>Selecciona una opción</MenuItem>        
                                            {                                                       
                                                arrayParte                                          
                                                .map((elem)=>(
                                                    <MenuItem key={ elem.id } value={ elem.id }> { elem.persona } &nbsp; <strong>({ elem.tipoParte ?? '' })</strong> </MenuItem>
                                                ))                                       
                                            } 

                                        </Select>

                                    </FormControl>

                                </Grid>   
                        }

                        {
                            tipoParteNotificar === 'Otro'
                            &&
                                <>

                                    <Grid size={{ md: 6, xs: 12 }} >
                        
                                        <Paper component="div" sx={ InputSearchStyle } >                            
                                            
                                            <InputBase 
                                                sx={{ ml: 1, flex: 1 }} 
                                                inputProps={{ 'aria-label': 'Buscar persona' }} 
                                                placeholder="Buscar persona"     
                                                value={ nombreCompleto }   
                                                onChange={ () => {} }             
                                                autoComplete="off"   
                                                disabled
                                            /> 

                                            <Button 
                                                size='small'
                                                variant='contained' 
                                                sx={ InputSearchButtonsStyle } 
                                                onClick={ () => setOpenDialogBuscarPersona( true ) }
                                            >
                                                <SearchIcon />
                                            </Button>         

                                            <Button 
                                                variant='contained' 
                                                size='small'
                                                sx={ InputSearchButtonsStyle } 
                                                onClick={ () => setOpenDialogNuevaPersona( true ) }
                                            >
                                                <PersonAddIcon />
                                            </Button>         

                                        </Paper>        

                                    </Grid>    

                                    <Grid size={{ md: 6, xs: 12 }}>
                                                                            
                                        <FormControl required fullWidth>
                                            
                                            <InputLabel>Tipo de parte</InputLabel>
                                        
                                            <Select                                                                          
                                                label="Tipo de parte"
                                                value={ tipoParte }
                                                onChange={ ( e ) => setTipoParte( parseInt( e.target.value.toString() ) ) }
                                            >
                                               
                                                <MenuItem key={0} value={0}>Selecciona una opción</MenuItem>      
                                                {
                                                    amparo?.success
                                                    ?                                                                    
                                                        tipoParteArray
                                                        .filter( (element ) => { return element.idTipoParte === 3 || element.idTipoParte === 4 || element.idTipoParte === 5; } )
                                                        .map( ( element ) => (
                                                            <MenuItem key={ element.idTipoParte } value={ element.idTipoParte }>{ element.descripcion }</MenuItem>                                                        
                                                        ))                                        
                                                    :                                                            
                                                        tipoParteArray
                                                        .filter( (element ) => { return element.idTipoParte === 1  || element.idTipoParte === 2 || element.idTipoParte === 9 || element.idTipoParte === 10 } )
                                                        .map( ( element ) => (
                                                            <MenuItem key={ element.idTipoParte } value={ element.idTipoParte }>{ element.descripcion }</MenuItem>                                                        
                                                        ))
                                                }

                                            </Select>

                                        </FormControl>

                                    </Grid>   
                                
                                </>
                        }

                        {
                            ( tipoNotificacion !== 0 ) && (
                            ( tipoBusqueda === 'Expediente' && expediente?.success ) ||
                            ( tipoBusqueda === 'Irregular' && irregular?.success ) ||
                            ( tipoBusqueda === 'Amparo' && amparo?.success ) ||
                            ( tipoBusqueda === 'ExhortoRecibido' && exhortoRecibido?.success ) )
                            &&                            
                                <Grid size={{ md: 12, xs: 12 }} >
                    
                                    <Paper component="div" sx={ InputSearchStyle } >     

                                        <InputBase 
                                            sx={{ ml: 1, flex: 1 }} 
                                            inputProps={{ 'aria-label': 'Buscar acuerdo a notificar' }} 
                                            placeholder="Buscar acuerdo a notificar"                                         
                                            value={ '' }  
                                            onChange={ () => {} }             
                                            autoComplete="off"   
                                            disabled
                                        /> 

                                        <Button 
                                            size='small'
                                            variant='contained' 
                                            sx={ InputSearchButtonsStyle } 
                                            onClick={ () => setOpenDialogBuscarAcuerdo( true ) }                                        
                                        >
                                            <SearchIcon />
                                        </Button>               

                                    </Paper>        

                                </Grid>  
                        }

                        {

                            acuerdoBusqueda.success
                            && 
                                <>

                                    <Grid size={{ md: 2, xs: 6 }} >

                                        <Typography gutterBottom variant="subtitle2" style={{ color:'gray', fontWeight: 'bold' }}>
                                            Acuerdo:
                                        </Typography>

                                    </Grid>

                                    <Grid size={{ md: 4, xs: 6 }} >

                                        <Typography gutterBottom variant="subtitle2" style={{ fontWeight: 'normal', color:'gray'  }}>
                                            { acuerdoBusqueda.tipoAcuerdo }
                                        </Typography>

                                    </Grid>

                                    <Grid size={{ md: 2, xs: 6 }} >

                                        <Typography gutterBottom variant="subtitle2" style={{ color:'gray', fontWeight: 'bold' }}>
                                            Fecha:
                                        </Typography>

                                    </Grid>

                                    <Grid size={{ md: 4, xs: 6 }} >

                                        <Typography gutterBottom variant="subtitle2" style={{ fontWeight: 'normal', color:'gray'  }}>
                                            { acuerdoBusqueda.fecha ? moment( acuerdoBusqueda.fecha ).format( 'DD-MM-YYYY' ) : '' }
                                        </Typography>

                                    </Grid>

                                </>           
                        }

                    </Grid>
                        
                </DialogContent>

                <DialogActions>

                    <Button color='secondary' disabled={ loadingGuardar } onClick={ handleCerrarDialog }>Cancelar</Button>

                    <Button 
                        variant="contained" 
                        loading={ loadingGuardar } 
                        onClick={ handleGenerarNotificacion }
                        disabled={
                            tipoBusqueda === '' || 
                            ((tipoParteNotificar === 'Actor/Demandado' && parte === 0) ||
                            (tipoParteNotificar === 'Otro' && (nombreCompleto === '' || tipoParte === 0))) ||
                            tipoNotificacion === 0 || formaNotificacion === 0 ||
                            ( autoridad === 0 && !expediente.success && !exhortoRecibido.success && !amparo.success && !irregular.success ) ||
                            ( tipoBusqueda === 'Expediente' && !expediente.success ) ||
                            ( tipoBusqueda === 'ExhortoRecibido' && !exhortoRecibido.success ) ||
                            ( tipoBusqueda === 'Amparo' && !amparo.success ) ||
                            ( tipoBusqueda === 'Irregular' && !irregular.success ) ||
                            ( !acuerdoBusqueda.success )
                        }
                    >
                        Guardar
                    </Button>

                </DialogActions>

            </Dialog>

            <DialogBuscarAmparo
                autoridad={ autoridad }
                openDialog={ openDialogBuscarAmparo } 
                seleccionarAmparo={ seleccionarAmparo }
                handleCloseDialog={ () => setOpenDialogBuscarAmparo( false ) } 
            />

            <DialogNuevaPersona 
                openDialog={ openDialogNuevaPersona } 
                handleCloseDialog={ () => setOpenDialogNuevaPersona( false ) } 
                seleccionarPersona={ seleccionarPersona }
            />

            <DialogBuscarPersona
                openDialog={ openDialogBuscarPersona } 
                handleCloseDialog={ () => setOpenDialogBuscarPersona( false ) } 
                seleccionarPersona={ seleccionarPersona }
            />

            <DialogBuscarAcuerdo
                openDialog={ openDialogBuscarAcuerdo } 
                handleCloseDialog={ () => setOpenDialogBuscarAcuerdo( false ) } 
                seleccionarAcuerdo={ seleccionarAcuerdo }
                idExpediente={ expediente.idExpediente }
                idIrregular={ irregular.idIrregular }
                idAmparo={ amparo.idAmparo }
                idExhortoRecibido={ exhortoRecibido.idExhortoRecibido }
            /> 

        </>
    )
}